import { render, staticRenderFns } from "./HeroBanner.vue?vue&type=template&id=065f60ea&scoped=true&"
import script from "./HeroBanner.vue?vue&type=script&lang=js&"
export * from "./HeroBanner.vue?vue&type=script&lang=js&"
import style0 from "./HeroBanner.vue?vue&type=style&index=0&id=065f60ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065f60ea",
  null
  
)

export default component.exports